module.exports = __webpack_public_path__ + "static/media/Vrachtwagen.f695c559.mp3";